{
	"language": {
		"select": "Choisir la langue",
		"sectionTitle": "Langue",
		"changeSuccess": "Langue modifiée avec succès"
	},
	"assistant": {
		"composer": {
			"placeholder": "Demandez à {{assistantName}}",
			"disclaimer": "{{assistantName}} peut faire des erreurs. Vérifiez les informations importantes."
		},
		"greeting": {
			"initialMessage": "👋 Bonjour, je suis **{{assistantName}}**, votre assistant d'apprentissage, et je suis là pour vous aider à mieux vous préparer à **{{context}} !** Penchons-nous sur l'item auquel vous avez répondu concernant **{{topic}}.**",
			"starter": "Bonjour, je suis **{{assistantName}}**. Comment puis-je vous aider ?"
		},
		"chips": {
			"askYourOwn": "Posez votre propre question",
			"askFollowUp": "Posez une question de suivi"
		},
		"emptyState": {
			"title": "{{assistantName}} est votre assistant d'apprentissage IA",
			"contextSubtitle": "Posez une question sur {{context}}",
			"activateSubtitle": "{{assistantName}} s'activera une fois que vous aurez répondu à la question"
		}
	},
	"dashboard": {
		"header": {
			"quickStudy": "Étude rapide",
			"examInfo": {
				"subtitle": {
					"setExamDate": "Définir la date d'examen",
					"examDateWithValue": "Date d'examen : <date>{{date}}</date>"
				}
			}
		},
		"reviewPrompt": {
			"buttons": {
				"couldBeBetter": "Peut mieux faire",
				"itsAwesome": "C'est génial"
			},
			"title": "Vous êtes sur une bonne lancée !",
			"body": "Nous sommes ravis de voir votre assiduité ! Comment se passe votre expérience avec l'application jusqu'à présent ? Accepteriez-vous de nous laisser un avis ?",
			"cta": "Plus tard"
		},
		"actions": {
			"studyWeak": "Cibler vos points faibles",
			"viewProgress": "Voir votre progression",
			"seeRank": "Consulter votre rang",
			"seeRankings": "Voir le classement",
			"unlock": "Débloquer le contenu Premium",
			"unlockTooltip": "Débloquez le contenu Premium pour accéder à des fonctionnalités exclusives et à des supports d'étude avancés",
			"startCustomSession": "Créer une session personnalisée",
			"startCustomSessionTooltip": "Lancez une session d'étude personnalisée pour cibler des domaines précis de votre programme",
			"takeDiagnostic": "Passer le diagnostic",
			"takeDiagnosticTooltip": "Passez un diagnostic pour évaluer votre niveau actuel et adapter votre plan d'étude en conséquence",
			"viewDiagnostic": "Voir les résultats du diagnostic",
			"viewDiagnosticTooltip": "Consultez les résultats de votre diagnostic pour voir vos points forts et vos axes de progrès",
			"viewPodcasts": "Écouter les podcasts",
			"viewPodcastsTooltip": "Accédez à des podcasts éducatifs pour enrichir votre apprentissage",
			"upgradeToPremium": "Passer à Premium",
			"upgradeToPremiumTooltip": "Passez à Premium pour accéder à tout le contenu et à toutes les fonctionnalités",
			"extendAccess": "Prolonger l'accès",
			"extendAccessTooltip": "Prolongez votre accès au contenu et aux fonctionnalités Premium",
			"setExamDate": "Définir la date d'examen",
			"setExamDateTooltip": "Définissez votre date d'examen pour suivre votre progression et bien vous préparer"
		},
		"exam": {
			"daysAgo_one": "Il y a {{count}} jour",
			"daysAgo_other": "Il y a {{count}} jours",
			"untilExam_one": "{{count}} jour avant l'examen",
			"untilExam_other": "{{count}} jours avant l'examen",
			"isToday": "L'examen a lieu aujourd'hui !"
		},
		"stats": {
			"mastery": "Maîtrise",
			"completed_one": "Item traité",
			"completed_other": "Items traités",
			"completedValue": "{{count}}",
			"xpEarned": "XP gagnés",
			"xpEarnedValue": "{{value}}",
			"accuracy": "Précision",
			"accuracyValue": "{{value}} %",
			"skillLevelTooltip": "Votre niveau estimé en {{skill, lowercase}} est {{level, lowercase}}",
			"itemsAnsweredTooltip": "Nombre total d'items que vous avez traités jusqu'ici",
			"responsesAnsweredTooltip": "Nombre total de réponses que vous avez envoyées jusqu'à présent",
			"examDateTooltip": "Votre examen a lieu le {{date}}",
			"skillCta": {
				"diagnostic": "Diagnostic",
				"practice": "S'entraîner"
			}
		},
		"menu": {
			"settings": "Paramètres",
			"profile": "Profil"
		},
		"diagnostics": {
			"title": "Diagnostics",
			"free": "Gratuit",
			"duration": "{{count}} {{item}} • {{minutes}} min",
			"completed": "Terminé : {{count}} {{item}}",
			"start": "Démarrer",
			"viewReport": "Voir le rapport",
			"resume": "Reprendre"
		},
		"practiceTests": {
			"title": "Examens blancs",
			"sectionalTestsTitle": "Tests par section",
			"diagnosticAssessmentsTitle": "Évaluations diagnostiques",
			"premiumChipTooltip": "Examens blancs complets Premium pour l'examen {{examName}}",
			"freeChipTooltip": "{{label}} pour l'examen {{examName}}",
			"freeChipTooltipDefault": "Évaluations diagnostiques gratuites pour l'examen {{examName}}",
			"completedDescription_one": "{{count}} item • {{date}}",
			"completedDescription_other": "{{count}} items • {{date}}",
			"activeDescription_one": "{{attempted}}/{{count}} item • temps restant : {{timeRemaining}}",
			"activeDescription_other": "{{attempted}}/{{count}} items • temps restant : {{timeRemaining}}",
			"activeDescriptionWithDates_one": "{{attempted}}/{{count}} item • temps restant : {{timeRemaining}} • Début : {{startedOn}} • Fin : {{endsOn}}",
			"activeDescriptionWithDates_other": "{{attempted}}/{{count}} items • temps restant : {{timeRemaining}} • Début : {{startedOn}} • Fin : {{endsOn}}",
			"notStartedDescription_one": "{{count}} item • {{duration}}",
			"notStartedDescription_other": "{{count}} items • {{duration}}",
			"notStartedDescriptionWithEnd_one": "{{count}} item • {{duration}} • Fin : {{endsOn}}",
			"notStartedDescriptionWithEnd_other": "{{count}} items • {{duration}} • Fin : {{endsOn}}",
			"viewResultsCta": "Voir les résultats",
			"startCta": "Commencer",
			"chips": {
				"items_one": "{{count}} item",
				"items_other": "{{count}} items",
				"progress_one": "{{attempted}}/{{count}} item",
				"progress_other": "{{attempted}}/{{count}} items",
				"timeRemaining": "temps restant : {{time}}",
				"startedOn": "Début : {{date}}",
				"endsOn": "Fin : {{date}}",
				"timeLeft": "{{time}} restant"
			},
			"status": {
				"notStarted": {
					"label": "Non commencé",
					"section": "Examens blancs complets"
				},
				"inProgress": {
					"label": "En cours",
					"section": "En cours"
				},
				"completed": {
					"label": "Terminé",
					"section": "Terminés"
				},
				"legacyReports": {
					"label": "Anciens rapports",
					"section": "Anciens rapports"
				},
				"migratedReports": {
					"label": "Rapports migrés",
					"section": "Rapports migrés"
				}
			}
		},
		"skills": {
			"title": "Compétences",
			"unlockSubtitle": "Débloquez premium pour vous entraîner",
			"startCta": "S'entraîner",
			"freeItemsIncludedChip": "Items gratuits inclus",
			"freeItemsAnsweredSubtitle_one": "{{answered, number}} sur {{count, number}} item gratuit répondu",
			"freeItemsAnsweredSubtitle_other": "{{answered, number}} sur {{count, number}} items gratuits répondus",
			"progressCards": {
				"questionTypesTitle": "Performance par type de question",
				"questionTypesSubtitle": "Vos résultats selon les types de question en {{skill}}",
				"proficiencyTitle": "Performance par niveau",
				"proficiencySubtitle": "Votre progression selon les niveaux en {{skill}}",
				"questionTypeCardSubtitle": "Progression par niveau de compétence",
				"bySkillTitle": "Performance par compétence",
				"bySkillSubtitle": "Progression globale sur l'ensemble des compétences",
				"needsImprovementTitle": "À améliorer",
				"needsImprovementSubtitle": "Compétences à travailler en priorité",
				"skillPerformanceTitle": "Performance en {{skill}}",
				"skillPerformanceSubtitle": "Progression par type de question et par niveau",
				"skillLevelSubtitle": "Votre progression à ce niveau de compétence",
				"skillsPerformanceTitle": "Performance des compétences",
				"performanceByItemDifficulty": "Performance par niveau des items",
				"performanceByItemDifficultyCaption_one": "Affiche votre précision par niveau, sur la base de {{count}} item traité",
				"performanceByItemDifficultyCaption_other": "Affiche votre précision par niveau, sur la base de {{count}} items traités",
				"questionTypePartSubtitle": "{{skill}} · Partie {{part}}",
				"activityGoalTitle": "Activité et progression vers l'objectif",
				"recentActivityTitle": "Activité récente",
				"goalProgressTitle": "Progression vers l'objectif",
				"goalProgressSubtitle": "Score global · 7 dernières semaines",
				"goalProgressInsight": "Vous progressez régulièrement. Vous êtes à 14 points de votre objectif et pourriez l'atteindre dans environ 3 semaines.",
				"goalProgressActualLabel": "Votre score",
				"goalProgressTargetLabel": "Objectif",
				"goalProgressTimeAxisLabel": "Temps",
				"goalProgressScoreAxisLabel": "Progression globale",
				"statusTitle": "Votre statut",
				"diagnosticsTitle": "Diagnostics",
				"diagnosticsReviewCta": "Consulter",
				"strengthsFocusTitle": "Points forts et axes de progrès",
				"strengthsFocusSubtitle": "Vos domaines les plus solides et les types de question à travailler davantage",
				"strengthsLabel": "Points forts",
				"focusAreasLabel": "Axes de progrès",
				"recommendedNextStepLabel": "Prochaine étape recommandée",
				"recommendedNextStepCta": "Démarrer",
				"practiceTestsViewMore": "Voir les {{count}} tests"
			},
			"proficiencySection": "S'entraîner par niveau de compétence"
		},
		"recommendedTasks": {
			"sectionTitle": "Recommandé pour vous",
			"startSessionAction": "S'entraîner",
			"resumeAction": "Reprendre",
			"reviewResultsAction": "Voir les résultats",
			"startTestAction": "Démarrer",
			"activeTestBody": "Terminez votre évaluation en cours",
			"completedTestBody": "Revoyez votre performance et vos réponses",
			"diagnosticBody": "Passez {{label}} pour vous familiariser avec le format de l'examen",
			"diagnosticDefaultLabel": "un diagnostic gratuit",
			"practiceTestBody": "Évaluez votre préparation à l'examen avec un examen chronométré.",
			"sectionalTestBody": "Passez un test ciblé pour pratiquer vos compétences en {{skills}}.",
			"weakSkillTitle": "Renforcez votre {{skill}}",
			"weakSkillBody": "Entraînement {{questionType}}, axé sur ce que vous ne maîtrisez pas encore.",
			"strongSkillTitle": "Gardez votre {{skill}} au point",
			"strongSkillBody": "Vous êtes solide ici. Un set rapide de {{questionType}} pour le rester.",
			"mixedSkillTitle": "Complétez votre {{skill}}",
			"mixedSkillBody": "Un set mixte sur {{questionTypes}}, axé sur ce que vous avez manqué.",
			"higherDifficultySkillTitle": "Passez à {{proficiency}}",
			"higherDifficultySkillBody": "Vous maîtrisez {{questionType}} à ce niveau. Ces items sont un cran plus durs.",
			"itemsChip_one": "{{count}} item",
			"itemsChip_other": "{{count}} items",
			"timeRemainingChip": "{{minutes}} min restantes",
			"timeRemainingChipCompact": "{{minutes}} min"
		},
		"itemTypes": {
			"answeredLabel_one": "Item traité",
			"answeredLabel_other": "Items traités",
			"answeredAll": "Tous",
			"answeredPartial": "{{answered}} sur {{total}}",
			"cardSubtitleResponses_one": "{{count}} réponse",
			"cardSubtitleResponses_other": "{{count}} réponses",
			"responsesLabel_one": "Réponse",
			"responsesLabel_other": "Réponses",
			"cardSubtitleComplete": "Tous les items traités",
			"cardSubtitlePartial": "{{attempted}} items traités sur {{total}}",
			"detail": {
				"skillLabel": "Compétence",
				"estimatedLevelLabel": "Niveau estimé"
			}
		},
		"tagSections": {
			"summary": "{{tagCount, number}} {{label, lowercase}} • $t(common.itemCount, {\"count\": {{itemCount}} })",
			"summaryWithoutItemCount": "{{tagCount, number}} {{label, lowercase}}",
			"responseCount_one": "{{count, number}} réponse",
			"responseCount_other": "{{count, number}} réponses"
		},
		"studyPack": {
			"freeContentBannerTitle_one": "{{count, number}} item d'entraînement gratuit inclus",
			"freeContentBannerTitle_other": "{{count, number}} items d'entraînement gratuits inclus",
			"freeContentBannerBody": "Entraînez-vous sur les items de {{skills}} à tout moment. Améliorez votre plan pour débloquer le Pack d'étude complet.",
			"freeContentBannerCta": "Démarrer l'entraînement gratuit",
			"freeSampleBanner": {
				"body_one": "Entraînez-vous sur les items sélectionnés de {{categories}} à tout moment. Améliorez votre plan pour débloquer {{count, number}} item supplémentaire.",
				"body_other": "Entraînez-vous sur les items sélectionnés de {{categories}} à tout moment. Améliorez votre plan pour débloquer {{count, number}} items supplémentaires.",
				"moreTags": "{{count, number}} {{label}} supplémentaires",
				"cta": "Améliorer"
			}
		}
	},
	"appbar": {
		"leaderboard": {
			"description": "Comparez vos résultats à ceux des autres"
		},
		"home": {
			"title": "Accueil"
		},
		"podcasts": {
			"description": "Écoutez des podcasts d'orthopédie animés par des experts."
		},
		"more": {
			"title": "Plus de paramètres"
		}
	},
	"emptyState": {
		"progress": {
			"title": "Aucune progression",
			"subtitle": "Votre progression s'affichera ici au fil de vos révisions",
			"cta": "Étudier maintenant"
		}
	},
	"errors": {
		"sessionCreation": {
			"title": "Erreur",
			"body": "Échec de la création de la session, veuillez réessayer"
		}
	},
	"mastery": {
		"labels": {
			"advanced": "Avancé",
			"highIntermediate": "Intermédiaire",
			"intermediate": "Intermédiaire",
			"basic": "Débutant",
			"none": "Sans réponse",
			"high": "Maîtrisé",
			"medium": "Presque maîtrisé",
			"low": "À travailler"
		}
	},
	"leaderboard": {
		"you": "C'est vous",
		"periods": {
			"all_time": "Depuis le début",
			"month": "Ce mois-ci",
			"week": "Cette semaine"
		},
		"scope": {
			"global": "Général",
			"friends": "Amis"
		},
		"friends": {
			"soon": "BIENTÔT",
			"comingSoonTitle": "Classement des amis",
			"comingSoonBadge": "Bientôt disponible",
			"comingSoonDescription": "Comparez votre progression à celle de vos amis et voyez qui est en tête de la classe."
		},
		"error": {
			"title": "Erreur de connexion",
			"description": "Impossible de charger le classement. Vérifiez votre connexion et réessayez.",
			"tryAgain": "Réessayer"
		},
		"empty": {
			"title": "Pas encore de classement",
			"description": "Le classement évolue à mesure que d'autres personnes étudient. Soyez la première personne à gagner des XP et à prendre la tête !",
			"startLearning": "Étudier maintenant"
		},
		"topPerformers": "Meilleurs participants",
		"yourPosition": "Votre position",
		"rankings": "Classement",
		"rankingsRange": "Classement • n°{{startRank}}–{{endRank}}",
		"unranked": {
			"title": "Gagnez des XP pour entrer au classement !",
			"description": "Démarrez une session d'étude pour gagner vos premiers points et entrer au classement.",
			"cta": "Démarrer votre première session"
		},
		"xpAmount": "<num>{{value}}</num> <unit>XP</unit>",
		"youBadge": "Vous",
		"podium": {
			"first": "1er",
			"second": "2e",
			"third": "3e"
		},
		"footer": {
			"gapHintToPass": "<num>+{{value}}</num><unit> XP</unit> <rest>pour dépasser le n°{{rank}}</rest>",
			"gapHintFromPodium": "<num>{{value}}</num><unit> XP</unit> <rest>vous séparent du podium</rest>"
		}
	},
	"lessons": {
		"explore": {
			"title": "Leçons",
			"statusFilter": {
				"all": "Tous",
				"inProgress": "En cours",
				"notStarted": "Non commencé",
				"completed": "Terminés"
			},
			"card": {
				"openCta": "Ouvrir",
				"resumeCta": "Reprendre",
				"viewResultsCta": "Voir les résultats",
				"duration_one": "{{count}} min",
				"duration_other": "{{count}} min"
			},
			"viewToggle": {
				"list": "Vue liste",
				"grid": "Vue grille"
			},
			"empty": {
				"filteredTitle": "Aucune leçon ne correspond à ce filtre",
				"filteredSubtitle": "Essayez un autre filtre de statut",
				"filteredCta": "Tout afficher",
				"noneTitle": "Aucune leçon trouvée",
				"noneSubtitle": "Essayez de retirer des filtres ou de lancer une nouvelle recherche",
				"noneCta": "Tout réinitialiser"
			}
		},
		"home": {
			"hero": {
				"greeting": "Bienvenue, {{name}} !",
				"greetingNoName": "Bienvenue !"
			},
			"stats": {
				"modulesDone": "Modules terminés",
				"dayStreak": "Série de jours",
				"minutesToday": "Min aujourd'hui"
			},
			"suggested": {
				"title": "Suggérées pour vous",
				"openModuleCta": "Ouvrir le module",
				"status": {
					"ready": "Prêt",
					"next": "Suivant"
				}
			},
			"all": {
				"title": "Toutes les leçons"
			},
			"emptyState": {
				"title": "Aucune leçon pour le moment",
				"subtitle": "Revenez bientôt pour découvrir de nouvelles leçons."
			},
			"card": {
				"duration_one": "{{count}} min",
				"duration_other": "{{count}} min"
			}
		},
		"overview": {
			"header": {
				"title": "Aperçu"
			},
			"startCta": "Commencer l'apprentissage",
			"objectives": {
				"title": "Objectifs d'apprentissage"
			}
		},
		"detail": {
			"takeQuizCta": "Faire le quiz",
			"progress": {
				"label": "Progression du module"
			},
			"activities": {
				"title": "Activités",
				"completedCount": "{{completed}} sur {{total}} terminées"
			},
			"artifact": {
				"startCta": "Start",
				"resumeCta": "Resume",
				"reviewCta": "Review",
				"listenAgainCta": "Listen again",
				"readAgainCta": "Read again"
			},
			"tabs": {
				"content": "Content",
				"insights": "Insights",
				"cme": "CME"
			}
		},
		"stats": {
			"insights": {
				"title": "Statistiques de progression"
			},
			"milestones": {
				"title": "Jalons du module",
				"startCta": "Start"
			}
		},
		"studyGuide": {
			"progress": {
				"label": "Lu"
			},
			"readTime": "{{count}} min de lecture",
			"sectionBadge": {
				"label": "Section {{number}} sur {{total}}"
			},
			"upNext": {
				"title": "À suivre"
			}
		},
		"cme": {
			"notStarted": {
				"title": "Start earning CME for this module",
				"description": "You haven't started this module yet. Complete the required activities to begin earning credit toward your certificate.",
				"cta": "Start learning"
			},
			"inProgress": {
				"title": "CME in progress",
				"description": "Complete all required activities to earn your CME credits and generate your certificate",
				"cta": "Continue learning"
			},
			"incompleteFootnote": "Certificates are only available after all CME requirements have been fulfilled. Partial completion does not qualify for credit.",
			"ready": {
				"completedOn": "Completed {{date}}",
				"title": "Certificate ready, {{credits}} credits earned",
				"description": "You've completed all required activities for this module.",
				"creditTableCaption": "What earned this credit",
				"downloadCta": "Download PDF",
				"redownloadCta": "Re-download PDF",
				"emailCta": "Email me",
				"downloadNotice": "You already downloaded a certificate for this module on {{date}}.",
				"downloadNoticeLink": "See that certificate",
				"footnote": "This credit will also be added to your total CME balance."
			}
		}
	},
	"sessionConfig": {
		"title": "Session d'étude personnalisée",
		"diagnostic": "Diagnostic",
		"skill": "Compétences",
		"Proficiency": "Niveau de compétence",
		"Question Type": "Types de question",
		"mastery": "Maîtrise",
		"sessionLength": "Durée de la session",
		"itemsChip_one": "{{count}} élément",
		"itemsChip_other": "{{count}} éléments",
		"durationEstimate": "{{minutes}} min",
		"durationRange": "{{min}}–{{max}} min",
		"noItemsTooltip": "Aucun item ne correspond aux filtres actuels",
		"setCount": "{{count}} {{type}}",
		"dismiss": "OK",
		"status": {
			"notAnswered": "Sans réponse",
			"needsWork": "À travailler"
		},
		"itemCount": "Vous allez traiter {{count}} items dans {{topics}}",
		"start": "Démarrer la session",
		"configuringSession": "Configuration de la session",
		"fetchingContent": "Récupération du contenu",
		"preparingMaterials": "Préparation des supports",
		"almostThere": "Presque terminé",
		"startingSession": "Démarrage de la session",
		"playIcon": "play-outline",
		"infoText": "Vous allez traiter **{{numItems}}** {{itemCount}}. Cela vous prendra environ **{{timeString}}**.",
		"customSummary": {
			"message": "Révisez $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) dans {{topics}}.",
			"messageWithMastery": "Révisez $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) dans {{topics}}, en ciblant $t(sessionConfig.customSummary.masteryLevelCount, {\"count\": {{masteryCount}}}) {{masteryLevels}}.",
			"messageAllMasteryLevels": "Révisez $t(sessionConfig.customSummary.itemCount, {\"count\": {{count}}}) dans {{topics}}, tous niveaux de maîtrise confondus.",
			"itemCount_one": "{{count}} item",
			"itemCount_other": "{{count}} items",
			"masteryLevelCount_one": "le niveau de maîtrise",
			"masteryLevelCount_other": "les niveaux de maîtrise",
			"allTopics": "les {{count}} thèmes",
			"more": "{{count}} de plus",
			"quotedMasteryLevel": "« {{masteryLevel}} »"
		},
		"quickStudy": {
			"title": "Étude rapide",
			"recommended": "Recommandé",
			"custom": "Personnalisé",
			"selectHelper": "Touchez une session pour la sélectionner, puis lancez-la quand vous le souhaitez.",
			"emptyRecommended": "Aucune session recommandée n'est disponible pour le moment.",
			"summary": "Révisez {{count}} items en {{skill}}. Durée estimée : {{minutes}} minutes.",
			"summary_questionType": "Révisez {{count}} items en {{skill}}, {{questionType}}. Durée estimée : {{minutes}} minutes.",
			"duration": "{{minutes}} min",
			"durationSelector": {
				"title": "Durée"
			},
			"levelSessions": {
				"rapidRecall": "Rappel rapide",
				"purposefulPractice": "Pratique ciblée",
				"focusFlow": "Pleine concentration",
				"itemsLabel": "Items de niveau {{level}}",
				"itemsLabelGeneric": "items",
				"summaries": {
					"rapidRecall": "Découvrez rapidement {{count}} items de niveau {{level}} auxquels vous n'avez pas encore répondu, pour élargir votre couverture pas à pas. Durée estimée : {{minutes}} minutes.",
					"purposefulPractice": "Travaillez un ensemble équilibré de {{count}} items de niveau {{level}}, en commençant par les contenus qui demandent le plus d'efforts. Durée estimée : {{minutes}} minutes.",
					"focusFlow": "Renforcez vos points faibles avec {{count}} items de niveau {{level}} traités avec une maîtrise faible ou moyenne. Durée estimée : {{minutes}} minutes."
				},
				"summariesGeneric": {
					"rapidRecall": "Découvrez rapidement {{count}} items auxquels vous n'avez pas encore répondu, pour élargir votre couverture pas à pas. Durée estimée : {{minutes}} minutes.",
					"purposefulPractice": "Travaillez un ensemble équilibré de {{count}} items, en commençant par les contenus qui demandent le plus d'efforts. Durée estimée : {{minutes}} minutes.",
					"focusFlow": "Renforcez vos points faibles avec {{count}} items traités avec une maîtrise faible ou moyenne. Durée estimée : {{minutes}} minutes."
				}
			},
			"lockedOptionsBanner": "Unlock {{names}} with Premium",
			"lockedOptionsBannerOverflow": "Unlock {{names}} and {{count}} more with Premium"
		}
	},
	"skillDetail": {
		"diagnosticInsight": "Pour personnaliser votre expérience, commencez par un quiz diagnostique. Les résultats de votre diagnostic serviront à créer votre plan d'étude."
	},
	"premium": {
		"chip": "Premium",
		"upgrade": "Passer à Premium",
		"unlockTitle": "Débloquez toute l'expérience {{productName}}",
		"unlockDescription": "Débloquez un entraînement personnalisé conçu autour de votre temps d'étude restant.",
		"readyTitle": "Soyez prêt pour votre examen du {{date}}",
		"tip": "Votre focus personnalisé : Premium identifie ce qu'il faut pratiquer ensuite et ajuste votre plan d'étude au fil de vos progrès."
	},
	"purchase": {
		"success": {
			"headerTitle": "Merci pour votre achat !",
			"accessGranted": "L'accès à votre {{name}} vous a bien été accordé",
			"studyPack": "Pack d'étude",
			"practiceTest": "Examen blanc",
			"combo": "Pack combiné",
			"documentTitle": "Achat",
			"summary_one": "Félicitations ! Le **produit** ci-dessous a été débloqué sur votre compte. Après avoir appuyé sur {{action}}, le contexte de l'application changera pour refléter l'examen : **{{examName}}**. Vous pouvez modifier ce choix à tout moment dans les paramètres de votre compte si vous souhaitez préparer un autre examen ou acheter un autre produit.",
			"summary_other": "Félicitations ! Les **{{count}} produits** ci-dessous ont été débloqués sur votre compte. Après avoir appuyé sur {{action}}, le contexte de l'application changera pour refléter l'examen : **{{examName}}**. Vous pouvez modifier ce choix à tout moment dans les paramètres de votre compte si vous souhaitez préparer un autre examen ou acheter un autre produit.",
			"unlockedDuration": "Félicitations ! Vous avez débloqué **{{duration}}** d'accès à **{{name}}**. L'accès expirera le **{{expiry}}**.",
			"storeNote": "Remarque : les Packs d'étude sont accessibles uniquement depuis nos applications mobiles. Téléchargez l'application adaptée à votre appareil.",
			"actions": {
				"goToHome": "Aller à l'accueil",
				"startDiagnostic": "Commencer {{label}}",
				"takeDiagnostic": "Passer {{label}}",
				"takeFreeDiagnostic": "Passer le diagnostic gratuit",
				"diagnosticLabel": "le diagnostic"
			}
		},
		"checkout": {
			"headerTitle": "Finalisez votre achat"
		},
		"paywall": {
			"studyPackDialogTitle": "Améliorez votre plan d'étude",
			"defaultDialogTitle": "Améliorez votre plan d'étude",
			"practiceTestDialogTitle": "Débloquez les examens blancs",
			"restorePurchaseDialogTitle": "Déjà acheté ?",
			"restorePurchaseDialogSubheadingWeb": "Sinon, essayez ceci :",
			"restorePurchaseDialogBody": "Si vous avez déjà acheté ce produit et qu'il reste verrouillé, essayez ceci :\n\n1. Vérifiez que vous êtes connecté au bon compte\n2. Vérifiez que le bon produit est sélectionné\n3. Vérifiez que votre abonnement n'a pas expiré\n4. Vérifiez que vous avez activé votre abonnement (regardez vos courriers indésirables)\n5. Si vous avez un code d'accès, [code d'accès]({{baseUrl}}/redeem)\n\nSi rien de tout cela ne s'applique, **cliquez ici**",
			"restorePurchaseDialogBodyWeb": "1. Vérifiez que vous êtes connecté avec la bonne adresse e-mail\n2. Vérifiez que le bon **[examen est sélectionné](/account/settings)**\n3. Vérifiez que votre abonnement n'a pas expiré\n\nSi rien de tout cela ne s'applique, **contactez le support**",
			"accesDuration": {
				"yearPlan": "Le plan de **{{duration}}** offre un accès prolongé et une flexibilité maximale pour étudier à votre rythme et préparer votre examen en profondeur.",
				"moreTime": "Si vous pensez avoir besoin de plus de temps pour étudier, vous pouvez opter pour le plan de **{{duration}}**.",
				"otherPlan": "Le plan de **{{duration}}** vous donne accès jusqu'au **{{expiryText}}**, ce qui vous laisse assez de temps pour étudier. {{moreTime}}"
			},
			"actions": {
				"upgrade": "Améliorer",
				"unlock": "Débloquer pour {{price}}",
				"subscribe": "S'abonner pour {{price}}",
				"extendAccess": "Prolonger l'accès",
				"accessHere": "Accéder ici",
				"redeemAccessCode": "Vous avez un code d'accès ?",
				"restorePurchase": "Déjà acheté ?",
				"restorePurchaseWeb": "Déjà acheté ou vous avez un code d'accès ?"
			},
			"subscriptionSummary": {
				"yearly": "Abonnement annuel • Renouvellement automatique • Résiliable à tout moment",
				"monthly": "Abonnement mensuel • Renouvellement automatique • Résiliable à tout moment",
				"weekly": "Abonnement hebdomadaire • Renouvellement automatique • Résiliable à tout moment",
				"generic": "Abonnement à renouvellement automatique • Résiliable à tout moment"
			},
			"planDuration": {
				"day_one": "{{count}} jour",
				"day_other": "{{count}} jours",
				"week_one": "{{count}} semaine",
				"week_other": "{{count}} semaines",
				"month_one": "{{count}} mois",
				"month_other": "{{count}} mois",
				"year_one": "{{count}} an",
				"year_other": "{{count}} ans"
			},
			"recommendedPlan": {
				"plan": "Nous vous recommandons le plan de **{{duration}}** pour préparer au mieux votre examen du **{{date}}**",
				"subscription": {
					"yearly": "Nous vous recommandons l'**abonnement annuel** pour un accès continu et une préparation optimale à votre examen du **{{date}}**",
					"monthly": "Nous vous recommandons l'**abonnement mensuel** pour un accès continu et une préparation optimale à votre examen du **{{date}}**",
					"weekly": "Nous vous recommandons l'**abonnement hebdomadaire** pour un accès continu et une préparation optimale à votre examen du **{{date}}**",
					"generic": "Nous vous recommandons un **abonnement** pour un accès continu et une préparation optimale à votre examen du **{{date}}**"
				}
			},
			"disclaimer": "À la confirmation de votre achat, vous obtiendrez un accès complet au contenu de ce produit pendant la durée sélectionnée. À l'expiration de cette période, vous perdrez l'accès au contenu réservé. Si vous souhaitez prolonger votre accès pour une raison quelconque (par exemple, si vous avez déplacé la date de votre examen), vous pouvez ajouter du temps via des achats intégrés supplémentaires. Pour en savoir plus, consultez nos [Conditions d'utilisation et notre Politique de confidentialité](https://memorang.com/legal)."
		}
	},
	"progress": {
		"tagProgress": {
			"subtitle": "D'après {{numItems}} {{item}} traités dans {{count}} {{type}}",
			"itemCount": "{{count}} {{item}}",
			"tooltip": "Voici votre progression dans {{count}} {{type}}. Elle repose sur les {{itemCount}} {{item}} que vous avez traités jusqu'ici."
		},
		"needsImprovement": {
			"title": "À améliorer",
			"subtitle": "{{type}} à travailler en priorité",
			"cta": "Réviser maintenant"
		},
		"mastery": {
			"high": "Maîtrisé",
			"medium": "Presque maîtrisé",
			"low": "À travailler",
			"count": "{{count}} {{item}} traités",
			"zeroTooltip": "Aucun item {{label}} pour l'instant sur {{total}} items traités",
			"highTooltip": "Vous maîtrisez {{count}} des {{total}} {{item}} traités",
			"mediumTooltip": "Vous progressez sur {{count}} des {{total}} {{item}} traités",
			"lowTooltip": "Vous devez vous entraîner davantage sur {{count}} des {{total}} {{item}} traités"
		},
		"stats": {
			"completion": "Avancement",
			"completionCount": "{{completed}}/{{total}} {{item}}",
			"completionTooltip": "Vous avez terminé {{completed}} {{item}} sur {{total}}"
		},
		"exams": {
			"title": "Examens blancs",
			"subtitle_one": "D'après {{count}} évaluation terminée",
			"subtitle_other": "D'après {{count}} évaluations terminées"
		},
		"summary": {
			"title": "Bilan d'apprentissage",
			"subtitle": "D'après {{count}} {{item}} traités",
			"tooltip": "Ce bilan montre vos niveaux de maîtrise et votre avancement sur un total de {{count}} {{item}}. Votre performance est mesurée à partir des sessions d'entraînement, des évaluations et des activités d'étude.",
			"mastery": "Maîtrise",
			"quickStats": "Statistiques rapides"
		},
		"languageLearning": {
			"proficiencyCardTitle": "Niveau en {{skill}}",
			"proficiencyCardTooltip": "Votre niveau actuel en {{skill, lowercase}} est {{level, lowercase}}",
			"itemTypesCardSubtitle_one": "{{count}} type d'item",
			"itemTypesCardSubtitle_other": "{{count}} types d'items",
			"itemTypesCardTitle": "Items de {{skill}}",
			"itemTypeLevelTooltip": "Votre niveau actuel en {{skill, lowercase}} est {{level, lowercase}} sur les questions de type « {{itemType}} »",
			"itemTypesFallbackTitle": "Types d'items",
			"itemTypesEmptyTitle": "Types d'items indisponibles",
			"itemTypesEmptySubtitle": "Nous n'avons pas trouvé de types d'items pour cette compétence. Revenez à Progression et réessayez.",
			"itemTypesEmptyCta": "Retour à la progression",
			"notAnswered": "Sans réponse",
			"answeredSubtitle_one": "D'après {{count}} item traité",
			"answeredSubtitle_other": "D'après {{count}} items traités",
			"responsesSubtitle_one": "Basé sur {{count}} réponse",
			"responsesSubtitle_other": "Basé sur {{count}} réponses",
			"testsTakenSubtitle_one": "D'après {{count}} test passé",
			"testsTakenSubtitle_other": "D'après {{count}} tests passés",
			"startFirstTest": {
				"title": "C’est parti",
				"itemsSubtitle_one": "{{count}} item",
				"itemsSubtitle_other": "{{count}} items",
				"guidance": {
					"diagnostic": "Commencez par un test diagnostique pour identifier vos points forts et adapter votre plan de révision.",
					"sectional": "Un test par section porte sur une seule partie de l’examen : vous obtenez un score en une session plus courte.",
					"fullMock": "Un examen blanc complet reproduit l’examen réel de bout en bout et donne le score le plus complet."
				}
			},
			"noScoresTitle": "Aucun score en {{skill, lowercase}} pour le moment",
			"noScoresSubtitle": "Passez votre premier test pour voir votre score estimé et la répartition des tâches.",
			"noScoresCta": "Commencer",
			"noScoresCardSubtitle": "D’après les tests que vous passez",
			"personalBestLabel": "Votre record personnel",
			"latestLabel": "Votre plus récent",
			"examCountdown_one": "Votre examen a lieu dans {{count}} jour",
			"examCountdown_other": "Votre examen a lieu dans {{count}} jours",
			"greeting": {
				"none": "C'est parti, {{firstName}} ! 🚀",
				"low": "Bon début, {{firstName}} — continuez ! 💪",
				"medium": "Continuez comme ça, {{firstName}} ! 💪",
				"high": "Vous y êtes presque, {{firstName}} ! 🎯"
			},
			"greetingNoName": {
				"none": "C'est parti ! 🚀",
				"low": "Bon début — continuez ! 💪",
				"medium": "Continuez comme ça ! 💪",
				"high": "Vous y êtes presque ! 🎯"
			},
			"stats": {
				"untilExam": "Date de l'examen",
				"itemsAnswered": "Items traités",
				"responsesAnswered": "Réponses"
			}
		}
	},
	"auth": {
		"incorrectPasscode": "Code d'accès incorrect",
		"incorrectPassword": "Mot de passe incorrect. Veuillez réessayer.",
		"passwordPlaceholder": "Saisissez votre mot de passe",
		"emailPlaceholder": "ex. : dave@gmail.com",
		"verify": {
			"openEmail": "Ouvrez votre e-mail pour continuer",
			"signInCta": "Vérification de votre compte...",
			"signUpCta": "Création de votre compte...",
			"contactSupport": "Vous ne voyez pas l'e-mail ? Vérifiez votre dossier spam ou",
			"contactSupportLink": "Contactez-nous",
			"resendMagicLink": "Renvoyer le lien magique",
			"resendMagicLinkIn": "Renvoyer le lien magique dans {{time}}",
			"signInBody": "Vous y êtes presque ! Nous vérifions vos informations pour vous connecter en toute sécurité à l'application {{appName}}.",
			"signUpBody": "C'est presque terminé ! Nous vérifions vos informations pour créer votre nouveau compte sur l'application {{appName}}.",
			"magicLinkEmail": "Nous avons envoyé un lien magique à **{{email}}**\nCliquez sur le lien reçu par e-mail pour vous connecter en toute sécurité.",
			"magicLinkEmailExpiry": "Ce lien expire dans 10 minutes",
			"confirmEmail": "Confirmez votre e-mail",
			"redirectingToApp": "Redirection vers l'application {{appName}}...",
			"appNotOpen": "L'application ne s'est pas ouverte ? Cliquez sur le bouton ci-dessous pour ouvrir l'application associée",
			"openApp": "Ouvrir l'application {{appName}}",
			"installAppPrompt": "Si rien ne se passe, vérifiez que l'application {{appName}} est installée sur votre appareil",
			"verifyAccountTitle": "Vérifiez votre compte",
			"emailResent": "Lien magique envoyé à {{email}}\nVérifiez votre boîte de réception, y compris les spams.",
			"verificationLinkExpired": "Lien de vérification expiré",
			"verificationLinkExpiredBody": "Les liens de vérification expirent au bout de 10 minutes et ne peuvent être utilisés qu'une seule fois. \nVous pouvez en demander un nouveau en vous reconnectant",
			"accountSetupTimeoutTitle": "Impossible de finaliser la connexion",
			"accountSetupTimeoutBody": "La configuration de votre compte prend plus de temps que prévu. Essayez de vous reconnecter ou contactez l'assistance si le problème persiste.",
			"loginAgain": "Se reconnecter",
			"contactSupportExpiredLink": "Si le problème persiste, faites-le nous savoir",
			"successTitle": "Vous êtes maintenant connecté dans un autre onglet",
			"successBody": "Fermez cet onglet ou continuez ici",
			"successCtaLabel": "Continuer ici",
			"needHelpLabel": "Besoin d'aide ?",
			"contactSupportButton": "Contactez-nous"
		},
		"contactSupportDialog": {
			"title": "Problème de connexion ?",
			"body": "Contactez notre service client si vous n'arrivez pas à vous connecter, ou réessayez",
			"cta": "Nous écrire"
		},
		"emailInstruction": {
			"default": "Si vous ne recevez pas d'e-mail, vérifiez vos dossiers courrier indésirable, spam et éléments récemment supprimés",
			"edu": "Si vous ne recevez pas d'e-mail, vérifiez vos dossiers courrier indésirable, spam et éléments récemment supprimés, ou contactez votre administrateur informatique"
		},
		"createSessionLoader": {
			"configuringSession": "Configuration de la session",
			"analyzingMastery": "Analyse de la maîtrise",
			"loadingContent": "Chargement du contenu"
		}
	},
	"onboarding": {
		"steps": {
			"profile": {
				"title": "Comment devons-nous vous appeler ?",
				"description": "Votre nom d'utilisateur apparaît dans les classements publics, tandis que votre nom reste privé.",
				"usernameLabel": "Nom d'utilisateur",
				"firstNameLabel": "Prénom",
				"lastNameLabel": "Nom",
				"avatarLabel": "Avatar",
				"avatarTooltip": "Les avatars sont générés automatiquement à partir de votre nom d'utilisateur.",
				"profileSaveFailed": "Impossible d'enregistrer votre profil. Veuillez réessayer."
			},
			"testDate": {
				"cta": "Continuer"
			},
			"examDate": {
				"daysAway": "Cela nous laisse {{value}} jours. Nous ciblerons immédiatement vos points faibles."
			},
			"skills": {
				"chooseAll": "Sélectionnez tout ce qui s'applique"
			},
			"plan": {
				"recommended": "Recommandé"
			},
			"toeicLevelOverview": {
				"title": "Tout le monde commence quelque part.",
				"description": "La pratique vous aide à maîtriser un niveau avant de passer naturellement au suivant.",
				"illustrationLabel": "Progression de Basique (A1–A2) à Intermédiaire (B1–B2) puis Compétent (C1).",
				"levels": {
					"basic": {
						"name": "Basique",
						"band": "A1–A2"
					},
					"intermediate": {
						"name": "Intermédiaire",
						"band": "B1–B2"
					},
					"proficient": {
						"name": "Compétent",
						"band": "C1"
					}
				},
				"progression": {
					"title": "Comment vous allez progresser",
					"practiceSessions": "Pratiquez les sessions recommandées",
					"buildMastery": "Développez votre maîtrise à votre niveau actuel",
					"growToward": "Continuez à progresser vers Compétent"
				},
				"levelDetails": {
					"title": "Ce que signifie chaque niveau",
					"scoreRange": "{{band}} · score {{min}}–{{max}}",
					"basic": {
						"name": "Utilisateur basique",
						"summary": "Anglais simple au travail",
						"examples": {
							"forms": "Formulaires et avis",
							"instructions": "Instructions",
							"announcements": "Annonces courtes"
						}
					},
					"intermediate": {
						"name": "Utilisateur intermédiaire",
						"summary": "Communication quotidienne au travail",
						"examples": {
							"emails": "E-mails et conversations",
							"customers": "Interactions avec les clients",
							"followUps": "Suivis de réunion"
						}
					},
					"proficient": {
						"name": "Utilisateur compétent",
						"summary": "Anglais professionnel et avancé",
						"examples": {
							"reports": "Rapports et présentations complexes",
							"negotiations": "Négociations nuancées",
							"highStakes": "Contextes professionnels à enjeux élevés"
						}
					}
				},
				"disclaimer": "Les scores TOEIC Link sont des repères alignés sur le CECRL, pas des seuils absolus. Reading et Listening progressent indépendamment — vous pouvez atteindre des niveaux différents dans chaque compétence."
			},
			"review": {
				"diagnosticChoice": {
					"title": "Diagnostic : {{title}}",
					"body": "{{count}} items pour cibler vos priorités",
					"duration": "{{minutes}} min"
				},
				"homeChoice": {
					"title": "Explorer par moi-même",
					"body": "Pas encore prêt à commencer, je préfère explorer l'application"
				}
			}
		},
		"common": {
			"changeLater": "Vous pourrez modifier ce choix plus tard"
		},
		"actions": {
			"previous": "Précédent",
			"finish": "Terminer",
			"start": "Commencer",
			"continue": "Continuer",
			"stepIndicator": "Étape {{step}} sur {{total}}"
		}
	},
	"more": {
		"profile": {
			"title": "À propos de vous"
		},
		"exam": {
			"title": "Votre examen"
		},
		"subscriptions": {
			"title": "Produits",
			"redeem": {
				"title": "Activer un achat"
			},
			"extend": {
				"cta": "Prolonger"
			}
		}
	},
	"examDate": {
		"noticeDialog": {
			"title": "Définissez votre date d'examen cible",
			"description": "Cette date sert uniquement à organiser votre planning d'étude dans l'application. Elle n'a aucune incidence sur votre inscription officielle à l'examen.",
			"dismissCta": "Plus tard",
			"confirmCta": "Définir la date"
		}
	},
	"account": {
		"title": "Mon compte",
		"currentExam": "Examen actuel",
		"subscriptions": "Produits",
		"examDate": "Date de l'examen",
		"examDateUpdated": "Date de l'examen fixée au {{date}}",
		"selectDate": "Sélectionner une date",
		"appearance": "Apparence",
		"features": "Fonctionnalités",
		"audioPlaybackTest": "Afficher la boîte de dialogue de test audio",
		"theme": "Thème",
		"selectTheme": "Choisir un thème",
		"themeOptions": {
			"system": "Système",
			"light": "Clair",
			"dark": "Sombre"
		},
		"accountInfo": "Compte",
		"username": "Nom d'utilisateur",
		"name": "Nom",
		"nameNotSet": "Non renseigné",
		"save": "Enregistrer",
		"editUsername": {
			"title": "Modifier le nom d'utilisateur"
		},
		"editName": {
			"title": "Modifier le nom"
		},
		"email": "E-mail",
		"dev": "Développement",
		"sandbox": "Environnement de test",
		"redoOnboarding": "Refaire l'introduction",
		"about": "À propos",
		"termsOfService": "Conditions d'utilisation",
		"privacyPolicy": "Politique de confidentialité",
		"aiToolsTos": "Conditions d'utilisation des outils d'IA",
		"support": "Assistance",
		"supportEmailBody": "Je vous contacte car j'ai besoin d'aide concernant [  ]\n\n\n\nVoici quelques informations utiles pour résoudre le problème plus rapidement : \n\nNom d'utilisateur associé au compte (visible dans les paramètres une fois connecté à l'application) :\n{{username}}\n\nAdresse e-mail associée à ma commande (visible dans les paramètres une fois connecté à l'application) :\n{{email}}\n\nNuméro de commande (généralement indiqué dans l'e-mail de reçu envoyé au moment de l'achat) :\n\nEst-il possible qu'un nom ou une adresse e-mail différents aient été utilisés lors de l'achat du produit ? Si oui, merci de les indiquer :\n\nPrénom et nom :\n\nAdresse e-mail :",
		"contactSupport": "Contacter l'assistance",
		"signOut": "Se déconnecter",
		"signOutConfirmation": "Voulez-vous vraiment vous déconnecter ?",
		"deleteAccount": "Supprimer le compte",
		"platform": "Plateforme",
		"partnerships": "Partenariats",
		"validUntil": "Expire le {{date}}",
		"extendValidity": "Prolonger l'accès",
		"redeemPurchase": "Échanger un achat",
		"redeemPurchaseNoneFound": "Aucun achat disponible à échanger",
		"redeemPurchaseCheckFailed": "Impossible de vérifier les achats. Veuillez réessayer.",
		"purchases": "Achats",
		"frequentlyAskedQuestions": "Questions fréquentes",
		"deleteFeedbackForm": {
			"placeholder": "Commentaires"
		}
	},
	"common": {
		"proficiencyLevelUnknown": "Données insuffisantes",
		"proficiencyLevelPendingTooltip": "Répondez à plus d'items de {{label}} pour estimer votre niveau",
		"on": "sur",
		"gotIt": "Compris",
		"goBack": "Retour",
		"topic": "thème",
		"itemCount_one": "{{count}} item",
		"itemCount_other": "{{count}} items",
		"examCount_one": "{{count}} examen",
		"examCount_other": "{{count}} examens",
		"questionCount_one": "{{count}} question",
		"questionCount_other": "{{count}} questions",
		"item_one": "item",
		"item_other": "items",
		"and": "et",
		"this": "ce",
		"of": "sur",
		"knowMore": "En savoir plus",
		"proficiency": "niveau",
		"didNotAnswer": "Items auxquels vous n'avez pas encore répondu",
		"notAnswered": "Sans réponse",
		"attempted": "traités",
		"attempt": "tentative",
		"activity": "activité",
		"performance": "Performance",
		"estimatedProficiency": "Niveau estimé",
		"details": "détails",
		"keepPracticing": "continuez à vous entraîner !",
		"leaveFeedback": "Laisser un commentaire",
		"copiedToClipboard": "Copié dans le presse-papiers",
		"eg": "p. ex.",
		"set": "définir",
		"hint": "indice",
		"itemType": "type d'item",
		"minute": "minute",
		"minutes": "{{count}} minutes",
		"hour": "heure",
		"hours": "{{count}} heures",
		"continue": "Continuer",
		"unlock": "Débloquer",
		"cancel": "Annuler",
		"view": "Voir",
		"switch": "Changer",
		"update": "Mettre à jour",
		"ok": "OK",
		"yes": "Oui",
		"free": "Gratuit",
		"answered": "Répondu",
		"correct": "Correct",
		"incorrect": "Incorrect",
		"marked": "Marqué",
		"unmarked": "Non marqué",
		"skipped": "Passé",
		"skill_one": "compétence",
		"skill_other": "compétences",
		"word_one": "mot",
		"word_other": "mots",
		"submitResponse": "Valider la réponse",
		"viewDetails": "Voir les détails",
		"sec_one": "s",
		"sec_other": "s",
		"point_one": "point",
		"point_other": "points",
		"week": "Semaine",
		"month": "Mois",
		"year": "Année",
		"day": "Jour",
		"selectTestDate": "Sélectionner la date d'examen",
		"points": "Points",
		"viewAll": "Tout voir",
		"timeline": "Chronologie",
		"save": "Enregistrer",
		"filters": {
			"selectAll": "Tout sélectionner",
			"deselectAll": "Tout désélectionner",
			"selectedCount": "Sélection : {{count}}",
			"expandSection": "Développer {{section}}",
			"collapseSection": "Réduire {{section}}"
		},
		"showMore": "Afficher plus",
		"showLess": "Afficher moins",
		"expandA11yLabel": "Développer la description",
		"collapseA11yLabel": "Réduire la description",
		"done": "Terminé",
		"clearAll": "Tout effacer",
		"clear": "Effacer",
		"datePicker": {
			"title": "Sélectionner une date",
			"enterDateLabel": "Saisir une date",
			"enterDateRangeLabel": "Saisir des dates",
			"dateLabel": "Date",
			"startDateLabel": "Date de début",
			"endDateLabel": "Date de fin",
			"dateRequiredError": "La date est obligatoire",
			"invalidDateFormatError": "Format de date invalide. Utilisez MM/DD/YYYY",
			"startAfterEndError": "La date de début ne peut pas être postérieure à la date de fin",
			"endBeforeStartError": "La date de fin ne peut pas être antérieure à la date de début",
			"minDateError": "La date doit être le {{date}} ou après",
			"maxDateError": "La date doit être le {{date}} ou avant",
			"dateRangeError": "La date doit être comprise entre {{startDate}} et {{endDate}}",
			"setDateCta": "Définir la date",
			"nextCta": "Suivant",
			"setTimeCta": "Définir l'heure"
		}
	},
	"session": {
		"choicePercentageTooltip": "{{percentage}} des apprenants ont choisi cette réponse.",
		"choiceCorrectA11yLabel": "Bonne réponse",
		"choiceIncorrectA11yLabel": "Mauvaise réponse",
		"choiceNotSelectedA11yLabel": "Non sélectionnée",
		"moreItemsAlertDialog": {
			"title": "Items supplémentaires",
			"cta": "Compris"
		},
		"results": {
			"followUps": {
				"title": "Questions de suivi"
			},
			"summary": {
				"sessionAnalysis": "Analyse de la session",
				"itemCount_one": "{{count}} item",
				"itemCount_other": "{{count}} items",
				"skilledItemCount_one": "{{count}} item de {{skills}}",
				"skilledItemCount_other": "{{count}} items de {{skills}}",
				"levelPhrase_one": "du niveau {{levels}}",
				"levelPhrase_other": "des niveaux {{levels}}",
				"message": "<bold>Excellent travail !</bold> Vous venez de terminer {{itemPhrase}} en {{timeTaken}}.",
				"messageWithLevels": "<bold>Excellent travail !</bold> Vous venez de terminer {{itemPhrase}} $t(session.results.summary.levelPhrase, {\"count\": {{levelCount}}, \"levels\": \"{{levels}}\"}) en {{timeTaken}}.",
				"proficiencyEstimateReady": "Votre niveau estimé en {{skill}} est <bold>{{currentLevel}}</bold>. Vous pouvez maintenant viser <bold>{{nextLevel}}</bold>.",
				"proficiencyEstimateKeepPracticing": "Votre niveau estimé en {{skill}} est <bold>{{currentLevel}}</bold>. Continuez à vous entraîner avant de passer à <bold>{{nextLevel}}</bold>.",
				"proficiencyEstimateHighest": "Votre niveau estimé en {{skill}} est <bold>{{currentLevel}}</bold>. Travail remarquable !",
				"mixedLevel": "Mixte",
				"overallScore": "Score global",
				"stats": {
					"itemsAttempted_one": "Item traité",
					"itemsAttempted_other": "Items traités",
					"pointsEarned_one": "Point gagné",
					"pointsEarned_other": "Points gagnés",
					"answeredCorrectly": "Réponses correctes",
					"timeTaken": "Temps passé",
					"target": "Objectif",
					"ofTotal": "sur {{total}}",
					"ofPointsTotal": "sur {{total}}",
					"skill": "Compétence",
					"skills": "Compétences",
					"questionType": "Type de question",
					"questionTypes": "Types de question",
					"proficiencyLevel": "Niveau de compétence",
					"proficiencyLevels": "Niveaux de compétence"
				}
			}
		},
		"prepBanner": {
			"audioStartsIn": "L'audio démarre dans {{seconds}} s",
			"audioStartsInPlayOnce": "L'audio démarre dans {{seconds}} s, une seule lecture",
			"videoStartsIn": "La vidéo démarre dans {{seconds}} s",
			"videoStartsInPlayOnce": "La vidéo démarre dans {{seconds}} s, une seule lecture",
			"recordingIn": "Enregistrement dans {{seconds}} s"
		},
		"timeOverrunBanner": {
			"message": "Temps écoulé. À l'examen réel, rien de ce qui suit ne serait noté. Vous pouvez continuer à vous entraîner."
		},
		"attributes": {
			"stimulus": "stimulus"
		},
		"stimulusTypes": {
			"reading": "Compréhension écrite",
			"listening": "Compréhension orale",
			"speaking": "Expression orale",
			"writing": "Expression écrite",
			"image": "Image"
		},
		"masteryLevels": {
			"belowBasic": "Inférieur à basique",
			"basic": "Basique",
			"belowLowIntermediate": "Inférieur à intermédiaire faible",
			"lowIntermediate": "Intermédiaire faible",
			"highIntermediate": "Intermédiaire avancé",
			"advanced": "Avancé",
			"proficiencySubtitle": "Au {{trademark}}, cela correspond à un score de **{{minScore}}-{{maxScore}}/30**",
			"infoSectionLabel": "Informations sur la section {{skill}}",
			"infoSectionText": {
				"Reading": "La section Compréhension écrite du {{trademark}} évalue votre capacité à lire et à comprendre des documents écrits utilisés en milieu universitaire. Elle comprend deux textes d'environ 700 mots chacun, avec 10 questions par texte. Comptez environ 35 minutes pour terminer la section Compréhension écrite.",
				"Listening": "La section Compréhension orale du {{trademark}} mesure votre capacité à comprendre des conversations et des cours en anglais. Elle porte sur la compréhension générale, la perception de l'attitude et du degré de certitude du locuteur, et la mise en relation des informations. Comptez environ 36 minutes pour terminer la section Compréhension orale.",
				"Speaking": "La section Expression orale du {{trademark}} mesure votre capacité à parler anglais efficacement en milieu universitaire. Les quatre questions ou tâches reproduisent des situations réelles que vous pourriez rencontrer en cours comme en dehors. Comptez environ 16 minutes pour terminer la section Expression orale.",
				"Writing": "La section Expression écrite du {{trademark}} mesure votre capacité à écrire en anglais en milieu universitaire et à présenter vos idées de façon claire et structurée. Vous saisirez vos réponses au clavier ; comptez environ 29 minutes pour terminer la section Expression écrite."
			}
		},
		"itemTypes": {
			"MCSS": "Choix multiple à réponse unique",
			"MCSSH": "Choix multiple à réponse unique avec surlignage",
			"MCMS": "Choix multiple à réponses multiples",
			"MCMSH": "Choix multiple à réponses multiples avec surlignage",
			"INSERT_TEXT": "Insertion de texte",
			"MATCH_MS": "Appariement à réponses multiples",
			"MCSSM": "Appariement à choix multiple et réponse unique",
			"MCMSM": "Appariement à choix multiple et réponses multiples",
			"MCGS": "Choix multiple avec texte à trous",
			"MCOS": "Choix multiple avec mise en ordre",
			"LISTENING_REPLAY": "Réécoute de l'audio",
			"AUDIO_INPUT": "Réponse audio",
			"ACADEMIC_DISCUSSION_RESPONSE": "Réponse à une discussion académique",
			"INTEGRATED_WRITING_RESPONSE": "Réponse écrite intégrée"
		},
		"passageStem": {
			"itemOfTotal": "Item {{current}} sur {{total}}",
			"questionOfTotal": "Question {{current}} sur {{total}}",
			"stimulusCorrespondsToNextItems": "Le stimulus ci-dessous correspond aux {{total}} items suivants",
			"passage": "Texte",
			"lecture": "Cours",
			"professorsQuestion": "Question du professeur",
			"listen": "Écouter",
			"openPassage": "Ouvrir le texte",
			"backToItem": "Retour à l'item",
			"notYetInserted": "Pas encore inséré",
			"insertedAtPosition": "Inséré en position {{position}}"
		},
		"hint": {
			"show": "Afficher l'indice"
		},
		"navigation": {
			"next": "Suivant",
			"exit": "Quitter",
			"saveAndExit": "Enregistrer et quitter",
			"previous": "Précédent",
			"skip": "Passer",
			"finish": "Terminer",
			"help": "Aide",
			"about": "Conseils",
			"questionsButtonLabel": "Navigation entre les questions",
			"questionsButtonTooltip": "Accédez à n'importe quelle question ou revoyez celles que vous avez marquées",
			"questionsButtonActiveFiltersA11y": "Filtres actifs : {{count}}",
			"recordingInProgressTooltip": "Vous ne pouvez pas quitter cet item pendant l'enregistrement",
			"questionNotReachedTooltip": "Vous n'avez pas encore atteint cette question"
		},
		"questionTips": {
			"hideFutureLabel": "Ne pas afficher les conseils automatiquement"
		},
		"toolbar": {
			"calculatorTooltip": "Ouvrir la calculatrice",
			"highlightTooltip": "Sélectionnez du texte pour surligner les informations importantes et les retrouver facilement",
			"markTooltip": "Marquez cette question pour y revenir avant de valider",
			"unmarkTooltip": "Cliquez pour retirer la marque de cette question"
		},
		"summary": {
			"viewFullInsights": "Voir toutes les analyses",
			"targetTooltip": "L'objectif de performance de cette session."
		},
		"stats": {
			"skill": "Compétence",
			"answered": "Répondu",
			"speed": "Vitesse",
			"duration": "Durée",
			"duration_tooltip": "Durée de votre réponse enregistrée : {{duration}} $t(common.sec, {\"count\": {{duration}}})",
			"confidence": "Confiance",
			"pointsEarned": "Points",
			"word": "Mot",
			"words": "Mots",
			"time_taken": "{{time}} {{sec}}",
			"time_taken_tooltip": "Vous avez mis {{time_taken}} $t(common.sec, {\"count\": {{time_taken}}}) à lire cet item et à y répondre",
			"skill_tooltip": "Compétence évaluée par cet item : {{skill}}",
			"answered_correct_tooltip": "La réponse que vous avez envoyée était correcte",
			"answered_incorrect_tooltip": "La réponse que vous avez envoyée était incorrecte",
			"skipped_tooltip": "Vous n'avez pas envoyé de réponse pour cet item",
			"words_tooltip": "Nombre de mots dans votre réponse écrite : {{count}}",
			"word_tooltip": "Nombre de mots dans votre réponse écrite : {{count}}",
			"confidence_tooltip": "Votre degré de confiance au moment d'envoyer votre réponse",
			"points_earned_tooltip_one": "Vous avez obtenu {{points}} point sur un maximum de {{maximumScore}} pour cet item",
			"points_earned_tooltip_other": "Vous avez obtenu {{points}} points sur un maximum de {{maximumScore}} pour cet item",
			"challengers_tooltip": "Nombre d'apprenants ayant répondu à cet item avant vous : {{count}}",
			"learning_mode_points_tooltip": "Points obtenus pour cette tentative : +{{xp}} XP",
			"pts_earned_tooltip": "Points obtenus pour cette tentative : {{xp}} XP"
		},
		"breakdownItemTypes": {
			"expandCta": "Afficher le détail"
		},
		"explanation": {
			"title": "Explication",
			"feedback": "Commentaires",
			"skippedFeedbackNotice": "Vous avez passé cette question : aucun commentaire personnalisé n'a été généré."
		},
		"followUps": "Questions de suivi",
		"suggestCorrection": "Suggérer une correction",
		"answer": {
			"correct": "Correcte",
			"incorrect": "Incorrecte",
			"skipped": "Passée"
		},
		"confidence": {
			"high": "Élevée",
			"medium": "Moyenne",
			"low": "Faible"
		},
		"endDialog": {
			"title": "Terminer la session maintenant ?",
			"confirmEndDiagnostic": "Voulez-vous vraiment terminer votre session ? Toute votre progression sera perdue et vous devrez recommencer.",
			"confirmEnd": "Il vous reste {{num}} {{itemLabel}}. Vous pouvez terminer maintenant ou continuer à étudier pour tout traiter.",
			"confirmEndNoAnswer": "Vous n'avez encore répondu à aucune question. Voulez-vous vraiment terminer maintenant ?",
			"confirmEndNoAnswerPositive": "Continuer à étudier",
			"confirmEndNoAnswerNegative": "Terminer maintenant"
		},
		"permissionDialog": {
			"title": "Accès au microphone requis",
			"descriptionWeb": "L'entraînement à l'expression orale utilise votre microphone. Votre navigateur bloque l'accès pour ce site : cliquez sur l'icône des autorisations à côté de l'adresse web, autorisez le microphone, puis réessayez.",
			"descriptionMobile": "L'entraînement à l'expression orale utilise votre microphone. Autorisez l'accès au microphone dans les paramètres de votre appareil pour continuer.",
			"promptDescriptionWeb": "L'entraînement à l'expression orale utilise votre microphone. Demandez l'autorisation puis choisissez Autoriser lorsque votre navigateur vous le demande.",
			"blockedDescriptionWeb": "L'accès au microphone est bloqué pour ce site. Cliquez sur l'icône à côté de l'adresse web, autorisez le microphone, puis demandez à nouveau l'autorisation.",
			"ok": "OK",
			"cancel": "Annuler",
			"openSettings": "Ouvrir les paramètres",
			"requestPermission": "Demander l'autorisation",
			"dismissAndExit": "Ignorer et quitter",
			"learnMore": "En savoir plus"
		},
		"audioPlaybackTestDialog": {
			"title": "Tester la lecture audio",
			"description": "L'application {{appName}} utilise l'audio à plusieurs endroits : stimuli, items de test et synthèse vocale. Pour une expérience optimale, testez votre audio ci-dessous. Une fois que tout fonctionne, continuez.",
			"troubleshooting": {
				"title": "Résoudre les problèmes audio",
				"volumeTitle": "Vérifier le volume de l'appareil",
				"volumeDescriptionWeb": "Réglez le volume avec les touches du clavier ou les paramètres système du menu ou de la barre des tâches",
				"volumeDescriptionMobile": "Utilisez les boutons de volume de l'appareil ou réglez-le dans les paramètres système",
				"outputTitle": "Vérifier le périphérique de sortie audio",
				"outputDescription": "Si vous utilisez un casque, vérifiez qu'il est bien connecté et sélectionné comme sortie active",
				"browserTitle": "Vérifier l'audio de l'onglet du navigateur",
				"browserDescription": "Repérez l'icône de haut-parleur coupé à côté du titre de l'onglet et réactivez le son le cas échéant."
			},
			"skipCheck": "Ne plus effectuer cette vérification",
			"workingButton": "Confirmer l'audio",
			"textToHear": "Vous devriez entendre : {{text}}"
		},
		"overall": "Global",
		"subskills": {
			"content": {
				"title": "Contenu"
			},
			"languageUse": {
				"title": "Usage de la langue"
			},
			"organizationAndDevelopment": {
				"title": "Organisation et développement"
			},
			"topicDevelopment": {
				"title": "Développement du sujet"
			},
			"delivery": {
				"title": "Élocution"
			}
		},
		"finalizing": {
			"title": "Finalisation de vos résultats",
			"gradingProgress": "Évaluation des réponses..."
		}
	},
	"questionTypes": {
		"descriptions": {
			"Repeat Sentence": "Une tâche d'expression orale où l'apprenant répète le plus fidèlement possible une phrase entendue.",
			"Read Aloud": "Un item d'expression orale où l'apprenant lit un passage à voix haute pour évaluation.",
			"Describe Image": "Une tâche d'expression orale où l'apprenant décrit en détail un support visuel.",
			"Write Essay": "Une tâche de réponse construite exigeant un essai structuré sur un sujet donné.",
			"Retell Lecture": "Une tâche d'expression orale où l'apprenant résume une conférence ou un exposé qu'il a écouté.",
			"Summarize Group Discussion": "Une tâche de compréhension orale où l'apprenant résume une discussion à plusieurs intervenants.",
			"Answer Short Question": "Une brève tâche d'expression orale consistant à répondre de façon concise à une seule question courte.",
			"Respond to a Situation": "Une tâche d'expression orale où l'apprenant répond de manière appropriée à une situation décrite.",
			"Summarize Written Text": "Une tâche de compréhension écrite où l'apprenant résume un passage avec ses propres mots.",
			"Reorder Paragraph": "Une tâche de compréhension écrite où l'apprenant remet des paragraphes mélangés dans le bon ordre.",
			"Fill in the Blanks (Dropdown)": "Une tâche de compréhension écrite où chaque blanc est complété à partir d'une liste déroulante d'options.",
			"Fill in the Blanks (Type In)": "Une tâche de compréhension orale où l'apprenant saisit le mot ou la courte expression manquante.",
			"Fill in the Blanks (Drag and Drop)": "Une tâche de compréhension écrite où les mots manquants sont placés en glissant les options dans les blancs.",
			"Multiple Choice, Single Answer": "Un item à choix multiple où l'apprenant sélectionne une seule réponse correcte.",
			"Multiple Choice, Single Answer (Reading)": "Un item à choix multiple de compréhension écrite où l'apprenant sélectionne une seule réponse correcte.",
			"Multiple Choice, Single Answer (Listening)": "Un item à choix multiple de compréhension orale où l'apprenant sélectionne une seule réponse correcte.",
			"Multiple Choice, Multiple Answers": "Un item où l'apprenant peut sélectionner plusieurs réponses correctes.",
			"Multiple Choice, Multiple Answers (Reading)": "Un item de compréhension écrite où l'apprenant peut sélectionner plusieurs réponses correctes.",
			"Multiple Choice, Multiple Answers (Listening)": "Un item de compréhension orale où l'apprenant peut sélectionner plusieurs réponses correctes.",
			"Summarize Spoken Text": "Une tâche de compréhension orale où l'apprenant rédige un résumé de ce qu'il a entendu.",
			"Highlight Correct Summary": "Une tâche de compréhension orale où l'apprenant surligne le résumé correspondant le mieux à l'audio.",
			"Select Missing Word": "Une tâche de compréhension orale de type texte à trous où l'apprenant choisit le mot manquant.",
			"Highlight Incorrect Words": "Une tâche de compréhension orale où l'apprenant surligne les mots de la transcription qui diffèrent de l'audio.",
			"Write from Dictation": "Une tâche de compréhension orale où l'apprenant transcrit une phrase entendue."
		}
	},
	"report": {
		"readFullInsights": "Lire toutes les analyses",
		"productName": "{{examName}} {{type}}",
		"startedAt": "Démarré à {{time}}",
		"itemTypesTitle": "Répartition par type d'item",
		"itemTypesFilterAll": "Tous",
		"questionTypeCardTitle": "Répartition par type d'item pour {{skill}}",
		"questionTypeCardSubtitle_one": "D'après {{count}} type d'item de {{skill}} dans cette session",
		"questionTypeCardSubtitle_other": "D'après {{count}} types d'items de {{skill}} dans cette session",
		"questionTypeCardAltSubtitle_one": "D'après {{count}} type d'item dans cette session",
		"questionTypeCardAltSubtitle_other": "D'après {{count}} types d'items dans cette session",
		"questionTypeRowSubtitle_zero": "Aucun item traité",
		"questionTypeRowSubtitle_one": "{{count}} item traité",
		"questionTypeRowSubtitle_other": "{{count}} items traités",
		"itemTypeDetail": {
			"review_one": "Revoir l'item",
			"review_other": "Revoir les items",
			"stats": {
				"answered_one": "Item traité",
				"answered_other": "Items traités",
				"avgTime": "Temps moyen par item"
			}
		},
		"reviewAnswersDialog": {
			"title": "Revoir les réponses",
			"sections": {
				"skills": "Compétences",
				"questionTypes": "Types de question",
				"proficiency": "Niveau de compétence",
				"performance": "Performance"
			},
			"summaryNone": "Sélectionnez des filtres contenant des items pour continuer.",
			"summaryAll_one": "Revoir {{count}} réponse.",
			"summaryAll_other": "Revoir les {{count}} réponses.",
			"summaryFiltered_one": "Revoir {{count}} réponse correspondant à {{filters}}.",
			"summaryFiltered_other": "Revoir {{count}} réponses correspondant à {{filters}}.",
			"reviewAnswers_one": "Revoir {{count}} réponse",
			"reviewAnswers_other": "Revoir {{count}} réponses",
			"more": "{{count}} de plus"
		},
		"itemDetail": {
			"title": "Revoir mes réponses",
			"filterAll": "Tous",
			"filterCorrect": "Corrects",
			"filterIncorrect": "Incorrects",
			"filterMarked": "Marqués",
			"emptyTitle": "Aucun item correspondant",
			"emptyDescription": "Aucun item de votre session ne correspond au filtre sélectionné ({{filter}}). Ajustez ou effacez les filtres pour voir plus de résultats.",
			"emptyCta": "Effacer les filtres"
		},
		"answerCardTitle": "Items traités",
		"answerCardSubtitle_one": "Découvrez vos résultats sur toutes les questions",
		"answerCardSubtitle_other": "Découvrez vos résultats sur les {{count}} questions",
		"skillsBreakdown": {
			"title": "Répartition par compétence",
			"subtitle_one": "D'après {{count}} item",
			"subtitle_other": "D'après {{count}} items"
		},
		"studyPack": "Pack d'étude",
		"practiceTestCompleted": "Examen blanc terminé",
		"studySessionCompleted": "Session d'étude terminée",
		"diagnosticSessionCompleted": "Session de diagnostic terminée",
		"timeElapsed": "Temps écoulé",
		"stats": {
			"answered": "TRAITÉS",
			"time elapsed": "TEMPS ÉCOULÉ",
			"avg speed": "VITESSE MOY.",
			"hints used": "INDICES UTILISÉS"
		},
		"pointsInfo": {
			"feedbackText": {
				"advanced": "Excellent travail ! Continuez à viser l'excellence !",
				"highIntermediate": "Vous vous en sortez très bien ! Continuez à cultiver vos points forts !",
				"lowIntermediate": "Votre progression est régulière. Continuez comme ça !",
				"basic": "Continuez à travailler pour développer vos capacités !"
			},
			"infoText": "Vous avez terminé **{{numActivities}} {{activityLabel}}** pour travailler {{skillsText}} {{skills}}. {{skillDetails}}. Au total, vous avez obtenu **{{numPointsEarned}} points sur {{numTotalPoints}}**, ce qui indique un **niveau {{compositeLevel}}** sur {{thisText}} {{skills}}. {{compositeFeedback}}",
			"infoText.singleSkill": "Vous avez terminé **{{itemCount}} {{itemLabel}}** portant sur votre compétence en **{{skill_1}}**. Vous avez obtenu **{{skill_1_score}} sur {{skill_1_total}}**, ce qui indique un niveau **{{proficiency}}**. {{compositeFeedback}}",
			"infoText.multiSkill": "Vous avez terminé **{{itemCount}} {{itemLabel}}** en travaillant vos compétences en **{{skills_text}}**. {{skill_details}} Au total, vous avez obtenu **{{overall_score}} points sur {{overall_total}}**, ce qui indique un niveau **{{overall_proficiency}}** sur ces compétences. {{compositeFeedback}}",
			"skillDetails": "En **{{skill}}**, vous avez obtenu **{{score}} sur {{total}}**, ce qui montre un niveau **{{proficiency}}**."
		},
		"actions": {
			"goToHome": "Aller à l'accueil",
			"studyMore": "Étudier plus",
			"studyFree": "Étudier gratuitement des {{tagTypes}}",
			"reviewAnswers": "Revoir les réponses"
		},
		"nextAction": {
			"title": "Recommandé : entraînement en {{focus}}",
			"dialog": {
				"title": "Session d'étude recommandée",
				"subtitle": "Concentrez-vous sur vos points faibles"
			},
			"fallback": {
				"title": "Continuez à vous entraîner",
				"description": "Créez une session d'étude autour des domaines que vous souhaitez travailler ensuite."
			}
		},
		"premium": {
			"upgradeCta": "Passer à Premium"
		},
		"disclaimer": {
			"title": "Avertissement",
			"summativeBody": "Les scores des examens blancs sont une estimation et ne garantissent pas le même résultat lors d'un véritable examen {{examName}}."
		},
		"performance": {
			"title": "Performance",
			"subtitle": "D'après {{count}} items",
			"correct": "Corrects",
			"correctItems": "{{count}} items",
			"incorrect": "Incorrects",
			"incorrectItems": "{{count}} items"
		},
		"mastery": {
			"performanceTitle": "Performance",
			"sessionMasteryTitle": "Niveau estimé",
			"subtitle_assessment": "D'après les {{count}} {{item}} de cette évaluation",
			"subtitle_session": "D'après les {{count}} {{item}} de cette session"
		},
		"sessionAnalysis": {
			"title": "Analyse de la session",
			"subtitle": "Analyse et recommandations personnalisées",
			"viewFullAnalysis": "Voir l'analyse",
			"feedbackDialog": {
				"body": "Nous publions des mises à jour presque tous les jours et cherchons à nous améliorer. Souhaitez-vous nous laisser un commentaire ?",
				"placeholder": "Saisissez votre commentaire ici",
				"cta": "Envoyer mon commentaire",
				"successMessage": "Commentaire envoyé. Merci !",
				"feedbackLimitError": "Le commentaire doit comporter au moins 10 caractères"
			},
			"menuActions": {
				"copy": "Copier",
				"altCopy": "Copier le texte du résumé",
				"altPositiveFeedback": "C'était utile",
				"positiveFeedback": "Bonne réponse",
				"negativeFeedback": "Mauvaise réponse",
				"reportIssue": "Signaler",
				"altReportIssue": "Signaler cette réponse",
				"emailSummary": "Envoyer le résumé par e-mail",
				"emailAlreadySent": "E-mail déjà envoyé",
				"copiedAnalysis": "Analyse copiée dans le presse-papiers",
				"emailSent": "E-mail envoyé à {{email}}. Si vous ne le recevez pas, vérifiez vos dossiers courrier indésirable, spam et éléments récemment supprimés",
				"emailFailed": "Échec de l'envoi de l'e-mail à {{email}}",
				"emailInstructionMessage": "Si vous ne recevez pas d'e-mail, vérifiez vos dossiers courrier indésirable, spam et éléments récemment supprimés, ou contactez votre administrateur informatique"
			}
		}
	},
	"feedback": {
		"successMessage": "Commentaires envoyés. Merci !"
	},
	"dialog": {
		"feedback": {
			"defaultFeedbackBody": "Qu'est-ce qui vous plaît ? Que pourrions-nous améliorer ? Nous améliorons la plateforme chaque jour et notre équipe lit tous les commentaires. Merci !",
			"title": "Partagez vos commentaires",
			"body": "Qu'est-ce qui vous plaît ? Que pourrions-nous améliorer ? Nous améliorons la plateforme chaque jour et notre équipe lit tous les commentaires. **Merci !**",
			"positiveBody": "Nous sommes ravis que cela vous ait été utile ! Dites-nous **ce qui vous a plu.**",
			"negativeBody": "Aidez-nous à comprendre ce qui n'a pas fonctionné pour **améliorer nos réponses.**",
			"placeholder": "Saisissez vos commentaires",
			"cta": "Envoyer les commentaires"
		},
		"report": {
			"title": "Envoyer un signalement",
			"body": "Aidez-nous à comprendre ce qui ne va pas dans cette réponse",
			"cta": "Envoyer le signalement"
		},
		"suggestCorrection": {
			"title": "Suggérer une correction",
			"body": "Aidez-nous à améliorer l'exactitude de ce contenu en **signalant toute erreur.**",
			"cta": "Envoyer"
		},
		"feedbackReasons": {
			"negative": {
				"inaccurate": {
					"title": "Inexacte",
					"description": "La réponse contient des informations incorrectes"
				},
				"notHelpful": {
					"title": "Pas utile",
					"description": "La réponse ne répondait pas à ma question"
				},
				"incomplete": {
					"title": "Incomplète",
					"description": "Il manque des détails importants dans la réponse"
				},
				"hardToUnderstand": {
					"title": "Difficile à comprendre",
					"description": "La réponse était confuse ou peu claire"
				},
				"other": {
					"title": "Autre",
					"description": "Autre chose"
				}
			},
			"report": {
				"misinformation": {
					"title": "Fausse information",
					"description": "La réponse contient des informations fausses ou trompeuses"
				},
				"harmfulContent": {
					"title": "Contenu nuisible ou offensant",
					"description": "Propos haineux, harcèlement ou langage inapproprié"
				},
				"violatesPolicies": {
					"title": "Non-respect des règles",
					"description": "Spam, autopromotion ou contenu illégal"
				},
				"other": {
					"title": "Autre",
					"description": "Décrivez le problème avec vos propres mots"
				}
			}
		},
		"faqs": {
			"title": "Questions fréquentes",
			"body": "Voici quelques-unes des questions les plus fréquentes sur l'application. Si vous avez d'autres questions, contactez-nous à support@memorang.ai"
		},
		"delete": {
			"title": "Supprimer le compte",
			"body": "Nous sommes désolés de vous voir partir et nous vous souhaitons beaucoup de réussite dans votre parcours universitaire et professionnel !",
			"options": "Trop cher|J'ai déjà passé mon examen|Le contenu ne m'a pas plu|Fonctionnalités manquantes|Autre",
			"confirmdelete": {
				"title": "Confirmer la suppression du compte",
				"cta": "Supprimer",
				"errorMessage": "Désolé, cette adresse e-mail ne correspond pas à ce compte. Veuillez réessayer",
				"successMessage": "Compte supprimé avec succès !",
				"validEmail": "Veuillez saisir une adresse e-mail valide"
			}
		}
	},
	"recorder": {
		"tapToRecord": "Appuyez pour enregistrer votre réponse",
		"responseAudioUnavailable": "L'audio de la réponse n'est pas disponible à l'écoute",
		"recording": "Enregistrement en cours",
		"recordingCompleted": "Enregistrement terminé",
		"getReady": "Préparez-vous",
		"timeIsUp": "Temps écoulé. Votre réponse n'a pas été enregistrée.",
		"alert": {
			"title": "Durée maximale atteinte",
			"body": "L'enregistrement s'est arrêté car il a atteint la durée maximale de {{maxDuration}} secondes."
		},
		"uiElementPressed": "Enregistrement arrêté - le stimulus a été ouvert pendant un enregistrement en cours."
	},
	"writing": {
		"placeholder": "Rédigez votre réponse ici...",
		"wordCount": "{{count}} {{word}}",
		"title": "Votre réponse",
		"submit": "Valider",
		"helper": {
			"range": "Rédigez {{min}}–{{max}} mots pour valider votre réponse",
			"min": "Rédigez au moins {{min}} mots pour valider votre réponse",
			"max": "Réduisez votre réponse à {{max}} mots maximum"
		}
	},
	"navbar": {
		"home": "Accueil",
		"progress": "Progression",
		"insights": "Analyses",
		"leaderboard": "Classement",
		"store": "Boutique",
		"more": "Plus",
		"redeem": "Utiliser un code",
		"study-pack": "Pack d'étude",
		"podcasts": "Podcasts",
		"modules": "Modules",
		"account": "Mon compte",
		"accountTab": "Compte",
		"privacy": "Confidentialité",
		"terms": "Conditions",
		"cme": "CME"
	},
	"redeem": {
		"contactSupportHint": "Vous avez saisi le code correctement et le problème persiste ? **Contactez l'assistance** et pensez à inclure votre code d'accès et les détails de votre achat",
		"olxDialog": {
			"unlockedTitle": "Accès débloqué",
			"expiredTitle": "Accès expiré",
			"testInfo": "**Examen :** {{examName}} | **Test :** {{bundleName}}",
			"upcomingBody_one": "Votre accès au test OLX a été débloqué !\n\nVous pourrez démarrer votre session dans **{{count}} jour**. Revenez plus tard pour commencer votre session depuis l'onglet Tests d'entraînement.",
			"upcomingBody_other": "Votre accès au test OLX a été débloqué !\n\nVous pourrez démarrer votre session dans **{{count}} jours**. Revenez plus tard pour commencer votre session depuis l'onglet Tests d'entraînement.",
			"activeBody": "Votre accès au test OLX est maintenant actif !\n\nVous pouvez démarrer votre session à tout moment avant le **{{date}}**.\n\nSouhaitez-vous commencer votre session maintenant ou plus tard ?",
			"expiredBody": "Votre accès au test OLX a expiré le **{{date}}**.\n\nVeuillez contacter votre professeur ou l'administrateur de votre établissement pour obtenir de l'aide.",
			"startNowCta": "Commencer maintenant",
			"startLaterCta": "Commencer plus tard"
		},
		"unexpectedError": "Une erreur inattendue s'est produite."
	},
	"redeemCode": {
		"titleRedeem": "Activer votre accès",
		"titleGranted": "Accès accordé",
		"formTitle": "Saisissez votre code d'accès",
		"accessCodeHint": "Si vous avez un code d'accès, saisissez-le ici, tirets compris.",
		"submit": "Utiliser le code",
		"access": "Accéder ici",
		"helpFindCode": "Besoin d'aide pour trouver votre code ?",
		"troubleRedeeming": "Un problème pour utiliser votre code ? Demandez à Assistant !",
		"skipStep": "Passer cette étape"
	},
	"autoRedeem": {
		"redeem": "Activer",
		"redeeming": "Activation...",
		"continue": "Continuer",
		"unredeemedPrompt_one": "Il y a **{{count}} produit** associé à l'adresse e-mail **{{email}}** qui n'a pas encore été activé. Voulez-vous l'ajouter à votre compte ?",
		"unredeemedPrompt_other": "Il y a **{{count}} produits** associés à l'adresse e-mail **{{email}}** qui n'ont pas encore été activés. Voulez-vous les ajouter à votre compte ?",
		"successMessage_one": "Félicitations ! Le **produit** ci-dessous a été débloqué sur votre compte. Après avoir appuyé sur Continuer, le contexte de l'application changera pour refléter l'examen : **{{examName}}**. Vous pouvez modifier ce choix à tout moment dans les paramètres de votre compte si vous souhaitez préparer un autre examen ou acheter un autre produit.",
		"successMessage_other": "Félicitations ! Les **{{count}} produits** ci-dessous ont été débloqués sur votre compte. Après avoir appuyé sur Continuer, le contexte de l'application changera pour refléter l'examen : **{{examName}}**. Vous pouvez modifier ce choix à tout moment dans les paramètres de votre compte si vous souhaitez préparer un autre examen ou acheter un autre produit."
	},
	"olxEligibility": {
		"goToPracticeTests": "Accéder aux examens blancs"
	},
	"moreChallenges": {
		"challenges": "Défis",
		"challengesCount": "{{value}} défis"
	},
	"tts": {
		"tooltip": "Écouter"
	},
	"commandBar": {
		"placeholder": "Rechercher...",
		"input": {
			"placeholder": "Saisissez une commande ou lancez une recherche"
		},
		"sections": {
			"quickActions": "Actions rapides"
		},
		"actions": {
			"changeExam": "Changer d'examen",
			"switchToDarkMode": "Passer en mode sombre",
			"switchToLightMode": "Passer en mode clair",
			"setExamDate": "Définir la date d'examen"
		}
	},
	"filterView": {
		"placeholder": "Rechercher un examen..."
	},
	"transcript": {
		"show": "Afficher la transcription",
		"hide": "Masquer la transcription"
	},
	"testDriver": {
		"appBar": {
			"logoAlt": "Logo de l'application",
			"testNameLabel": "Nom du test",
			"sectionLabel": "Section",
			"back": "Retour",
			"pause": "Pause",
			"menuLabel": "Plus d'options"
		},
		"pteSummativeAppbar": {
			"progressBarLabel": "Progression du test",
			"of": "sur",
			"pauseSession": "Suspendre la session",
			"timerTooltip": {
				"item": "Temps restant pour cette question",
				"section": "Temps restant dans cette section",
				"test": "Temps restant dans ce test"
			}
		},
		"pteSummativeBottomAppbar": {
			"next": "Suivant"
		},
		"progressBar": {
			"timeLeftLabel": "Temps restant pour cette question",
			"timeLeftForUnit": "Temps restant pour cette unité",
			"questionOf": "Question {{current}} sur {{total}}",
			"questionProgress": "<b>{{current}}</b> sur {{total}}",
			"timesUp": "Temps écoulé",
			"statusTooltips": {
				"answered": "Traitée",
				"inProgress": "En cours",
				"skipped": "Passée",
				"notSeen": "Non vue"
			}
		},
		"timeRemainingDialog": {
			"title": "Il vous reste du temps",
			"body": "Il reste du temps sur cette unité. Souhaitez-vous revoir vos réponses avant de valider ?",
			"reviewCta": "Revoir mes réponses"
		},
		"itemTypes": {
			"reorderParagraph": {
				"sourceTitle": "Source",
				"answerTitle": "Votre réponse",
				"remainingBadge": "{{count}} restants",
				"placedBadge": "{{count}} placés",
				"pointsBadge": "{{earned}}/{{max}} points",
				"emptyHint": "Faites glisser ici les paragraphes du panneau de gauche"
			}
		}
	},
	"redeemCopilot": {
		"contactSupport": {
			"title": "Informations d'assistance",
			"emailLabel": "E-mail",
			"subjectLabel": "Objet",
			"messageBodyLabel": "Corps du message",
			"appDetailsLabel": "Détails de l'application",
			"appNameLabel": "Nom",
			"versionLabel": "Version",
			"platformLabel": "Plateforme"
		},
		"chat": {
			"assistantTitle": "Assistant d'assistance {{tenantName}}",
			"fallbackTitle": "Chat",
			"betaWarning": "Cet assistant IA est en **version bêta** ; les réponses peuvent parfois être inexactes ou incomplètes.",
			"greeting": "Bonjour 👋 Avez-vous du mal à accéder à un produit ? Je suis là pour vous aider ! Commençons par cerner le problème. Laquelle des situations suivantes décrit le mieux la vôtre ?\n\n1. J'ai un code d'accès, mais il ne semble pas fonctionner.\n2. J'ai effectué un achat, mais je ne trouve pas mon code d'accès.\n3. J'aurais dû recevoir un accès via mon établissement, mais je ne trouve pas mon code d'accès.\n4. J'avais accès à un produit auparavant, mais il m'est actuellement inaccessible.\n\nVeuillez saisir le numéro correspondant à votre problème.",
			"input": {
				"label": "Écrivez un message...",
				"sendLabel": "Envoyer"
			}
		},
		"accessContent": {
			"redeemedTitle": "🎉 Activé avec succès",
			"previouslyRedeemedTitle": "🚀 Déjà activé",
			"subtitle": "Accédez à votre contenu ici",
			"expires": "Expire le : {{date}}",
			"openCta": "Ouvrir"
		},
		"purchases": {
			"title": "🎉 Codes d'accès trouvés",
			"subtitle": "Utilisez-les pour accéder à votre contenu",
			"accessCodesLabel_one": "Code d'accès",
			"accessCodesLabel_other": "Codes d'accès",
			"moreCodes_one": "(+ {{count}} de plus)",
			"moreCodes_other": "(+ {{count}} de plus)",
			"featuresLabel": "Fonctionnalités",
			"redeemCta": "Utiliser le code"
		}
	},
	"versionChecker": {
		"banner": {
			"message": "Nouvelle version disponible, cliquez sur actualiser pour mettre à jour.",
			"refreshCta": "Actualiser",
			"refreshA11yLabel": "Actualiser pour mettre à jour l'application",
			"dismissTooltip": "Ignorer",
			"dismissA11yLabel": "Ignorer la notification de mise à jour"
		}
	},
	"cme": {
		"type": "Type de CME",
		"chooseExportMethod": "Choisir la méthode d'exportation",
		"selectDateRange": "Sélectionner la plage de dates",
		"from": "De",
		"to": "À",
		"sendPdfTo": "Envoyer le PDF à {{email}}",
		"downloadCertificate": "Télécharger le certificat en PDF",
		"amaCategory1": "AMA PRA Category 1",
		"creditEarnedSubtitle": "Crédit CME gagné",
		"confirmYourName": "Confirmez votre nom",
		"certificateNameNotice": "Ce nom sera imprimé sur votre Certificat CME.",
		"firstName": "Prénom",
		"lastName": "Nom de famille",
		"firstNamePlaceholder": "Entrez votre prénom",
		"lastNamePlaceholder": "Entrez votre nom de famille",
		"confirm": "Confirmer",
		"creditsEarnedTitle": "CME gagnés",
		"creditRatioCaption": "12 Défis = 1 Crédit CME",
		"earned": "Gagné",
		"available": "Disponible",
		"creditsValue": "{{count}} CME",
		"exportCertificate": "Exporter le Certificat CME",
		"exportDisabledCaption": "Vous devez gagner au moins 1 crédit CME pour exporter votre certificat",
		"viewDisclaimer": "Voir la clause de non-responsabilité CME"
	},
	"podcast": {
		"detail": {
			"descriptionHeading": "Description",
			"tagsHeading": "Étiquettes",
			"citationsHeading": "Références",
			"playing": "En lecture"
		},
		"a11y": {
			"artwork": "Pochette de {{title}}",
			"playEpisode": "Lire l'épisode, {{duration}}",
			"pauseEpisode": "Mettre l'épisode en pause",
			"play": "Lire",
			"pause": "Pause",
			"addToQueue": "Ajouter à la file d'attente",
			"removeFromQueue": "Retirer de la file d'attente",
			"addBookmark": "Enregistrer",
			"removeBookmark": "Retirer des favoris",
			"seekBar": "Barre de lecture",
			"skipPrevious": "Revenir à la piste précédente",
			"skipNext": "Passer à la piste suivante",
			"rewind": "Reculer de {{seconds}} secondes",
			"fastForward": "Avancer de {{seconds}} secondes",
			"playbackSpeed": "Vitesse de lecture {{speed}}x"
		}
	}
}
